import _defineProperty from "/codebuild/output/src3842342609/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Maintains custom user-agent state set by external consumers.
var customUserAgentState = {};
/**
 * Sets custom user agent state which will be appended to applicable requests. Returns a function that can be used to
 * clean up any custom state set with this API.
 *
 * @note
 * This API operates globally. Calling this API multiple times will result in the most recently set values for a
 * particular API being used.
 *
 * @note
 * This utility IS NOT compatible with SSR.
 *
 * @param input - SetCustomUserAgentInput that defines custom state to apply to the specified APIs.
 */

var setCustomUserAgent = function setCustomUserAgent(input) {
  var _customUserAgentState;

  // Save custom user-agent state & increment reference counter
  // TODO Remove `any` when we upgrade to TypeScript 5.2, see: https://github.com/microsoft/TypeScript/issues/44373
  customUserAgentState[input.category] = input.apis.reduce(function (acc, api) {
    var _acc$api;

    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, api, {
      refCount: (_acc$api = acc[api]) !== null && _acc$api !== void 0 && _acc$api.refCount ? acc[api].refCount + 1 : 1,
      additionalDetails: input.additionalDetails
    }));
  }, (_customUserAgentState = customUserAgentState[input.category]) !== null && _customUserAgentState !== void 0 ? _customUserAgentState : {}); // Callback that cleans up state for APIs recorded by this call

  var cleanUpCallbackCalled = false;

  var cleanUpCallback = function cleanUpCallback() {
    // Only allow the cleanup callback to be called once
    if (cleanUpCallbackCalled) {
      return;
    }

    cleanUpCallbackCalled = true;
    input.apis.forEach(function (api) {
      var apiRefCount = customUserAgentState[input.category][api].refCount;

      if (apiRefCount > 1) {
        customUserAgentState[input.category][api].refCount = apiRefCount - 1;
      } else {
        delete customUserAgentState[input.category][api]; // Clean up category if no more APIs set

        if (!Object.keys(customUserAgentState[input.category]).length) {
          delete customUserAgentState[input.category];
        }
      }
    });
  };

  return cleanUpCallback;
};

var getCustomUserAgent = function getCustomUserAgent(category, api) {
  var _customUserAgentState2, _customUserAgentState3;

  return (_customUserAgentState2 = customUserAgentState[category]) === null || _customUserAgentState2 === void 0 ? void 0 : (_customUserAgentState3 = _customUserAgentState2[api]) === null || _customUserAgentState3 === void 0 ? void 0 : _customUserAgentState3.additionalDetails;
};

export { getCustomUserAgent, setCustomUserAgent };